export default __webpack_public_path__ + "static/media/selfie-ktp.c42aa6a3.png";